export const concatAddress = (
  address: string | undefined,
  startCount: number = 6,
  endCount: number = 6,
) => {
  if (!address || address.length < 10) return address; // Handle invalid or short addresses
  return `${address.slice(0, startCount)}...${address.slice(-endCount)}`;
};
